module.exports = "<settings-nav class=\"settings-nav\"></settings-nav>\n\n<div class=\"settings-page\" ui-view></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/engineer/screens/settings/settings.html
// module id = 343
// module chunks = 0